// extracted by mini-css-extract-plugin
export var phone = "_2s-0";
export var phoneDragging = "_2s-1";